import { DatePipe, isPlatformBrowser } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  mergeApplicationConfig,
  PLATFORM_ID,
  provideAppInitializer,
  provideZonelessChangeDetection,
  REQUEST
} from '@angular/core';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter, ViewTransitionInfo, withInMemoryScrolling, withViewTransitions } from '@angular/router';
import { NOTIFICATION_SETTINGS_URL_TOKEN } from '../oex-ui-kit/services/notifications.service';
import { STORAGE_TOKEN } from '../oex-ui-kit/services/storage.service';
import { ViewTransitionService } from '../oex-ui-kit/services/view-transition.service';
import { routes } from './app.routes';
import { httpInterceptor } from './services/http-interceptor';
import { StartupService } from './services/startup.service';
import { StorageService } from './services/storage.service';

export const initializeApplication = async () => {
  // Temporary fix to prevent Angular CLI execute app initializer during build process
  const req = inject(REQUEST, { optional: true });
  const platformId = inject(PLATFORM_ID);
  if (!req && !isPlatformBrowser(platformId)) {
    return;
  }

  await inject(StartupService).initialize();
};

const onViewTransitionCreated = (info: ViewTransitionInfo) => {
  const viewTransitionService = inject(ViewTransitionService);
  viewTransitionService.currentTransition.set(info);

  info.transition.finished.finally(() => {
    viewTransitionService.currentTransition.set(undefined);
  });
}

export const appConfig: ApplicationConfig = {
  providers: [
    DatePipe,
    provideHttpClient(withInterceptors([httpInterceptor]), withFetch()),
    provideZonelessChangeDetection(),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' }),
      withViewTransitions({
        skipInitialTransition: true,
        onViewTransitionCreated
      })
    ),
    provideClientHydration(withEventReplay()),
    provideAppInitializer(initializeApplication),
    { provide: NOTIFICATION_SETTINGS_URL_TOKEN, useValue: '/portal/notifications' },
    { provide: STORAGE_TOKEN, useClass: StorageService }
  ]
};

const browserConfig: ApplicationConfig = {
  providers: [
    provideAnimationsAsync(),
    provideAnimations()
  ]
};

export const config = mergeApplicationConfig(appConfig, browserConfig);
